import * as React from 'react';
import { Grid } from '@mui/material';
import AppService from '../services/app.service';

interface Props {
  id?: string;
  vertical?: boolean;
  onChange?: (value: string) => void;
  children?: React.ReactNode;
}

export const Swipe: React.FunctionComponent<Props> = (props) => {
  const isMobile =AppService.isMobile();
  const [touchStartX, setTouchStartX] = React.useState(0);
  const [touchEndX, setTouchEndX] = React.useState(0);
  const [touchStartY, setTouchStartY] = React.useState(0);
  const [touchEndY, setTouchEndY] = React.useState(0);
  const minSwipeDistance = isMobile? 2 : 20;

  const onTouchStart = (e: React.TouchEvent) => {
    setTouchStartX(e.targetTouches[0].clientX);
    setTouchEndX(0);
    setTouchStartY(e.targetTouches[0].clientY);
    setTouchEndY(0);
    touch(e, 'start');
  }
  
  const onTouchMove = (e: React.TouchEvent) => {
    setTouchEndX(e.targetTouches[0].clientX);
    setTouchEndY(e.targetTouches[0].clientY);
    touch(e, 'move');
  }
  
  const onTouchEnd = (e: React.TouchEvent) => {
    touch(e, 'end');
    setTouchStartX(0);
    setTouchStartY(0);
  }

  const touch = (e: React.TouchEvent, type: string) => {
    const distanceX = touchStartX - touchEndX;
    const distanceY = touchStartY - touchEndY;
    
    if (!touchEndX || !touchEndY) return;
    
    if ((!props.vertical) && Math.abs(distanceY) < Math.abs(distanceX)) {
      if (distanceX > minSwipeDistance) props.onChange?.(type + 'left');
      else if (distanceX < -minSwipeDistance) props.onChange?.(type + 'right');
    }
    else if (props.vertical && Math.abs(distanceX) < Math.abs(distanceY)) {
      if (distanceY > minSwipeDistance) props.onChange?.(type + 'up');
      else if (distanceY < -minSwipeDistance) props.onChange?.(type + 'down');
    } 
  }

  return (
    <Grid item xs={12} md={12} onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd} >
      {props.children}
    </Grid>
  );
}
